import { inject } from "@angular/core";
import { CanDeactivateFn, Router } from "@angular/router";
import { ReservaService } from "@shared/services/apl-afiliacion/reserva/reserva.service";
import { LoadingBackdropService } from "@shared/services/loading-backdrop.service";
import {
  EnumIconos,
  UtilPopupService,
} from "@shared/services/util-popup.service";
import { firstValueFrom } from "rxjs";

export const reservaGuard: CanDeactivateFn<unknown> = async () => {
  const reservaService = inject(ReservaService);
  const loadingService = inject(LoadingBackdropService);
  const utilPopupService = inject(UtilPopupService);
  const router = inject(Router);

  if (!reservaService.getUuid()) {
    return true;
  }

  const result = await utilPopupService.mostrarMensajeAel3(
    "¿Está seguro de salir de la afiliación?",
    "No se guardarán los cambios.",
    EnumIconos.info,
    EnumIconos.logo,
    {
      showCancelButton: true,
      confirmButtonText: "SI",
      mostrarConfirmButton: true,
    }
  );

  if (!result.isConfirmed) {
    router.navigateByUrl(router.url);
    return false;
  }

  try {
    loadingService.show();

    const uuid = reservaService.getUuid();

    if (uuid) {
      await firstValueFrom(reservaService.eliminarReserva({ uuid }));
      reservaService.setUuid(null);
    }

    localStorage.removeItem("horaInicioReserva");

    return true;

  } catch {
    loadingService.hide();
    await utilPopupService.mostrarMensajeAel(
      "Algo ha salido mal",
      `Ha ocurrido un error, inténtalo más tarde.`,
      EnumIconos.error,
    );

    router.navigateByUrl(router.url);

    return false;

  } finally {
    loadingService.hide();
  }
};